<template>
  <v-app :theme="activeTheme">
    <slot :currentTheme="activeTheme" :toggleTheme="toggleTheme" :selectedStore="selectedStore"></slot>
    <NotificationSystem />
  </v-app>
</template>

<script setup lang="ts">


import { computed } from 'vue'
import { useUIStore } from '@/stores/useUIStore'
import { useStoresStore } from '@/stores/useStoresStore'
import NotificationSystem from './NotificationSystem.vue'

const uiStore = useUIStore()
const storesStore = useStoresStore()

const currentTheme = computed(() => uiStore.currentTheme)
const selectedStore = computed(() => storesStore.currentSelectedStore)

const activeTheme = computed(() => {
  if (selectedStore.value?.theme) {
    if (currentTheme.value === 'dark') {
      return 'dark'
    }
    return selectedStore.value.theme
  }
  return currentTheme.value
})

function toggleTheme() {
  uiStore.toggleTheme()
}
</script>
